module.exports = __webpack_public_path__ + "static/media/disablenotification.aced4015.svg";